/**
 * Image configuration for variant generation.
 * Separated from app_config.js to avoid Svelte component imports during SSR.
 */

const admin_variants = [
  { width: 200, quality: 0.60 }  // thumbnails, can be aggressive
];

// WebP for smaller sizes (universal browser support). 0.90, not lower: at
// 0.82 skin lost its texture and dark, smooth backgrounds broke into visible
// blocks (portraits on black); 0.90 costs about 80% more bytes.
const content_webp_variants = [
  { width: 640, quality: 0.90 },
  { width: 768, quality: 0.90 },
  { width: 1024, quality: 0.90 },
];

// AVIF for larger sizes (20-47% smaller than WebP)
const content_avif_variants = [
  { width: 1366, quality: 0.65 },
  { width: 1920, quality: 0.65 },
  { width: 2560, quality: 0.65 },
  { width: 3840, quality: 0.65 }
];

const SUPPORTED_IMAGE_EXTENSIONS = new Set(['jpg', 'jpeg', 'png', 'webp', 'avif', 'heif', 'heic']);

export const IMAGE_CONFIG = {
  admin_variants,
  content_webp_variants,
  content_avif_variants,
  content_sizes: content_webp_variants.map(variant => variant.width),
  default_avif_effort: 4,
  supported_image_extensions: SUPPORTED_IMAGE_EXTENSIONS
};
